import { fetchCA } from '../../helpers/utils'

export const apiCreateSession = async (data) => {
  if (!data) return
  return fetchCA(`/session`, {}, 'POST', data)
}
export const apiEndSession = async (data) => {
  const { userID } = data
  if (!userID) return
  return fetchCA(`/session/${encodeURIComponent(userID)}`, {}, 'DELETE', data)
}
export const apiGetSession = async (userID) => {
  if (!userID) return
  return fetchCA(`/session/${encodeURIComponent(userID)}`)
}
